import React, { useEffect, useRef, useState } from "react";
import "./NewTradingHistory.scss";
import ReactTable from "../ReactTable/ReactTable";
import { ReactComponent as UncheckedCheckbox } from "../../assets/icons/NewIcons/uncheckedCheckbox.svg";
import { ReactComponent as CheckedCheckbox } from "../../assets/icons/NewIcons/checkedCheckboxWhite.svg";
import { ReactComponent as AddIcon } from "../../assets/icons/NewIcons/AddIconWhite.svg";
import { ReactComponent as ChartIcon } from "../../assets/icons/chartIcon.svg";
import dayjs from "dayjs";
import CreateTrader from "../Trademate/CreateTrader";
import CombinedPopup from "../Popups/CombinedPopup";
import { fetchTraderJournalCreate } from "../../store/reducers/trademateReducer";
import { useDispatch } from "react-redux";
import TradingViewChart from "./NewCalender/TradingGraph/TradingViewChart";
import { FormatUSD } from "../../utilities/string";
import { Modal } from "antd";
import CandleStickChart from "../TraderChart/Traderchart";
import TradeDetailsCard from "./TradeDetailsCard";
import { useNavigate } from "react-router";

const NewTradingHistory = ({ TradingHistory, add = true }) => {
  const formatDate = (dateString) => {
    return dayjs(dateString).format("DD MMM YYYY");
  };

  const formatTime = (dateString) => {
    return dayjs(dateString).format("HH:mm:ss");
  };

  const sortedTradingHistory =
    TradingHistory &&
    TradingHistory?.slice().sort((a, b) => {
      return new Date(b.date).getTime() - new Date(a.date).getTime();
    });

  // POPUP States
  const [Show, setShow] = useState(false);
  const navigate = useNavigate();

  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [SPopup, setSPopup] = useState(false);
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");
  const [candleStickModal, setCandleStickModal] = useState(false);
  const [candleStickSymbol, setCandleStickSymbol] = useState(false);
  const [selectedTradeDate, setSelectedTradeDate] = useState(null);
  const [positionInfo, setPositionInfo] = useState({});
  const [positions, setPositions] = useState({});
  const [period, setPeriod] = useState({
    start_date: null,
    end_date: null
  })
  const [candleStickTime, setCandleStickTime] = useState(null);
  const [active, setActive] = useState(null);
  const [activeTimeFrame, setActiveTimeFrame] = useState(null);
  const dateRanges = [
    { label: '1D', value: '1d' },
    { label: '1W', value: '1w' },
    { label: '1M', value: '1m' },
    { label: '3M', value: '3m' },
    { label: '6M', value: '6m' },
    // { label: 'YTD', value: 'ytd' },
    { label: '1Y', value: '1y' },
  ];
  console.log(positionInfo, 'positionInfo');
  const timeFrames = {
    '1d': ['1m', '5m', '15m', '30m', '1h', '3h'],
    '1w': ['1h', '3h', '6h', '12h', '1d'],
    '1m': ['1d', '1w'],
    '3m': ['1d', '1w', '1m'],
    '6m': ['1d', '1w', '1m'],
    '1y': ['1d', '1w', '1m'],
  }

  const containerRef = useRef(null);

  useEffect(() => {
    handleClick('1d');
  }, []);

  const handleRowClick = (row) => {
    const clickedPosition = row?.original?.position;

    const matchingItems = filteredData?.filter(item => item.position === clickedPosition);
    console.log(matchingItems,'matchingItems');
    setPositionInfo((prev) => ({
      ...prev,
      info: matchingItems,
      [matchingItems?.length > 1 ? 'first' : 'second']: false,
      [matchingItems?.length > 1 ? 'second' : 'first']: true
    }))
    

    const newPositions = matchingItems.reduce((acc, item) => {
      if (item.position && item.date) {
        const date = new Date(item.date);
        date.setSeconds(0, 0);

        const formattedDate = `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}T` +
          `${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}:00Z`;

        if (acc[item.position]) {
          acc[item.position].push(formattedDate);
        } else {
          acc[item.position] = [formattedDate];
        }
      }
      return acc;
    }, {});

    setPositions(newPositions);

   
  };

  useEffect(() => {
    if (
      positionInfo &&
      period &&
      selectedTradeDate &&
      candleStickSymbol &&
      candleStickTime &&
      positions
    ) {
      navigate('/trade-details', {
        state: {
          positionInfo,
          period,
          selectedTradeDate,
          candleStickSymbol,
          candleStickTime,
          positions,
        },
      });
    }
  }, [
    positionInfo,
    period,
    selectedTradeDate,
    candleStickSymbol,
    candleStickTime,
    positions,
  ]);
  


  console.log(selectedTradeDate?.split(' ')?.[0], 'selectedTradeData');
  const calculateDates = (period, storedDate) => {
    const storedDateObj = new Date(storedDate);
    if (isNaN(storedDateObj.getTime())) {
      throw new Error("Invalid stored date");
    }

    let startDate = new Date(storedDateObj);
    let endDate = new Date(storedDateObj);

    switch (period) {
      case '1d':
        break; // No change
      case '1w':
        startDate.setDate(startDate.getDate() - 3);
        endDate.setDate(endDate.getDate() + 3);
        break;
      case '1m':
        startDate.setMonth(startDate.getMonth() - 1);
        endDate.setMonth(endDate.getMonth() + 1);
        break;
      case '3m':
        startDate.setMonth(startDate.getMonth() - 3);
        endDate.setMonth(endDate.getMonth() + 3);
        break;
      case '6m':
        startDate.setMonth(startDate.getMonth() - 6);
        endDate.setMonth(endDate.getMonth() + 6);
        break;
      case 'ytd':
        startDate = new Date(storedDateObj.getFullYear(), 0, 1);
        endDate = new Date(storedDateObj);
        break;
      case '1y':
        startDate.setFullYear(startDate.getFullYear() - 1);
        endDate.setFullYear(endDate.getFullYear() + 1);
        break;
      default:
        startDate = new Date(0);
        endDate = new Date();
        break;
    }

    return {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
  };




  const dispatch = useDispatch();

  const handleClick = (value) => {
    setActive(value);

    const { startDate, endDate } = calculateDates(value, selectedTradeDate);
    setPeriod({
      start_date: startDate,
      end_date: endDate
    })
    if (value !== '1d') {
      setCandleStickTime(null)
    }
    if (value == '1d') {
      setCandleStickTime(selectedTradeDate)
    }
    setActiveTimeFrame(timeFrames?.[value]?.[0])
  };

  console.log(period, 'selectedTRADEDate');

  const handleFormSubmit = (Data) => {

    dispatch(fetchTraderJournalCreate(Data))
      .then((res) => {
        if (res) {
          // SUCCESS
          setSPopup(true);
          setCombinedPUHead("Success");
          setCombinedPUBody("Journal created!");
          setPopUpType("success");
        } else {
          setSPopup(true);
          setCombinedPUHead("Error");
          setCombinedPUBody("Something went wrong");
          setPopUpType("error");
        }
      })
      .catch((error) => {
        alert("Error");
      });
  };
  const [tradingData, setTradingData] = useState(null);


  const columns = [
    {
      Header: "Deal ID",
      accessor: "deal",
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>,
    },
    {
      Header: "Open Time",
      accessor: "date",
      Cell: ({ row, value }) => (
        <div className="dateBox" onClick={() => setTradingData(row.originalF)}>
          <p>{value ? formatDate(value) : "N/A"}</p>
          <p>{value ? formatTime(value) : "N/A"}</p>
        </div>
      ),
    },
    {
      Header: "Symbol",
      accessor: "symbol",
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Action",
      accessor: "action", // Buy or Sell
      Cell: ({ value }) => (
        <div
          className={`${value === "Buy"
            ? "profitValue"
            : value === "Sell"
              ? "lossValue"
              : ""
            }`}
        >
          {value ?? "N/A"}
        </div>
      ),
    },
    {
      Header: "Lots",
      accessor: "volume", // Number of lots
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Open Price",
      accessor: "price", // Price at which the trade was opened
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Profit",
      accessor: "profit", // Profit/loss from the trade
      Cell: ({ value }) => (
        <div
          className={`${value > 0 ? "profitValue" : value < 0 ? "lossValue" : ""
            }`}
        >
          {FormatUSD(value) ?? "0"}
        </div>
      ),
    },
    {
      Header: "Profit Rate",
      accessor: "profitRate", // Profit rate percentage
      Cell: ({ value }) => (
        <div>{value != null ? value.toFixed(2) : "N/A"}</div>
      ), // Check for null or undefined
    },
    {
      Header: "Commission",
      accessor: "commission", // Commission on the trade
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Swap",
      accessor: "swap", // Swap fees
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Reason",
      accessor: "reason", // Reason for the trade
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Entry",
      accessor: "entry", // Entry status (e.g., "In")
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "SL",
      accessor: "stop_loss", // Stop-loss value
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "TP",
      accessor: "take_profit", // Take-profit value
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Order",
      accessor: "order", // Order ID
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Position",
      accessor: "position", // Position ID
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Volume Closed",
      accessor: "volumeClosed", // Volume closed
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
  ];

  const filters = ["Profit", "Buy", "Sell"];

  const [createTradeVisibility, setCreateTradeVisibility] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [filterVisibility, setFilterVisibility] = useState(false);
  const filterRef = useRef(null);
  const buttonRef = useRef(null);
  const traderRef = useRef(null);
  const tradeButtonRef = useRef(null);
  const [filteredData, setFilteredData] = useState(TradingHistory);

  const handleFilterToggle = (filter) => {
    setSelectedFilters((prevFilters) => {
      const newFilters = { ...prevFilters };
      newFilters[filter] = !newFilters[filter];
      return newFilters;
    });
  };

  // Close filter dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setFilterVisibility(false);
      }
    };

    // Add event listener for clicks
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const applyFilters = () => {
    let data = TradingHistory;

    // If "Profit" and "Buy" are selected, show only Buy trades with profit > 0
    if (selectedFilters["Profit"] && selectedFilters["Buy"]) {
      data = data.filter((trade) => trade.action === "Buy" && trade.profit > 0);
    } else if (selectedFilters["Buy"] && selectedFilters["Sell"]) {
      data = TradingHistory.filter(
        (trade) => trade.action === "Buy" || trade.action === "Sell"
      );
    }
    // If "Profit" and "Sell" are selected, show only Sell trades with profit > 0
    else if (selectedFilters["Profit"] && selectedFilters["Sell"]) {
      data = data.filter(
        (trade) => trade.action === "Sell" && trade.profit > 0
      );
    }

    // If "Profit", "Buy", and "Sell" are selected, show both Buy and Sell trades with profit > 0
    else if (
      selectedFilters["Profit"] &&
      selectedFilters["Buy"] &&
      selectedFilters["Sell"]
    ) {
      data = data.filter(
        (trade) =>
          (trade.action === "Buy" || trade.action === "Sell") &&
          trade.profit > 0
      );
    }

    // If only "Profit" is selected, show trades with profit > 0 (no action filter)
    else if (selectedFilters["Profit"]) {
      data = data.filter((trade) => trade.profit > 0);
    }

    // If "Buy" is selected, show only Buy trades (no profit filter)
    else if (selectedFilters["Buy"]) {
      data = data.filter((trade) => trade.action === "Buy");
    }

    // If "Sell" is selected, show only Sell trades (no profit filter)
    else if (selectedFilters["Sell"]) {
      data = data.filter((trade) => trade.action === "Sell");
    }

    setFilteredData(data);
  };

  useEffect(() => {
    applyFilters();
  }, [selectedFilters, TradingHistory]);

  const handleCross = () => {
    setCreateTradeVisibility(false);
  };

  useEffect(() => {
    if (createTradeVisibility) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [createTradeVisibility]);
  const priceData = [
    { time: "2024-10-10", value: 42400.0 },
    { time: "2024-10-11", value: 42500.0 },
    { time: "2024-10-12", value: 42583.75 },
  ];

  const tradeMarkers = [
    {
      time: "2024-10-10T13:37:50",
      position: "aboveBar",
      color: "red",
      shape: "arrowDown",
      text: "Sell @ 424689.55",
    },
    {
      time: "2024-10-11T16:32:15",
      position: "belowBar",
      color: "blue",
      shape: "arrowUp",
      text: "Close @ 42583.75",
    },
  ];

  const chartOptions = {
    backgroundColor: "#f8f9fa",
    textColor: "#333333",
    gridColor: "#e0e0e0",
    borderColor: "#cccccc",
    lineColor: "#4CAF50",
  };

  const columnss =
    Array.isArray(filteredData) && filteredData.length > 0
      ? Object.keys(filteredData[0])?.map((key) => {
        let columnProps = {
          Header: key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase()),
          accessor: key,
          Cell: ({ value }) => <div>{value ?? "N/A"}</div>,
        };

        // Handle specific columns
        if (key === "profit") {
          columnProps.Cell = ({ value }) => (
            <div
              className={
                value > 0 ? "profitValue" : value < 0 ? "lossValue" : ""
              }
            >
              {FormatUSD(value) ?? "0"}
            </div>
          );
        } else if (key === "date") {
          columnProps.Cell = ({ value }) => (
            <div className="dateBox">
              <p>{value ? formatDate(value) : "N/A"}</p>
              <p>{value ? formatTime(value) : "N/A"}</p>
            </div>
          );
        } else if (key === "profitRate") {
          columnProps.Cell = ({ value }) => (
            <div>{value != null ? value.toFixed(2) : "N/A"}</div>
          );
        } else if (key === "symbol") {
          columnProps.Cell = ({ row }) => (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>{row.original.symbol ?? "N/A"}</span>
              {/* <button
                onClick={() => {
                  setCandleStickModal(true);
                  setCandleStickSymbol(row.original.symbol);
                  setSelectedTradeDate(row.original.date);
                  setCandleStickTime(row.original.date);
                  handleRowClick(row)
                }}
                style={{ background: "none", border: "none", cursor: "pointer" }}
              >
                <ChartIcon />
              </button> */}
            </div>
          );
        } else if (key === "action") {
          columnProps.Cell = ({ value }) => (
            <div
              className={`${value === "Buy"
                ? "profitValue"
                : value === "Sell"
                  ? "lossValue"
                  : ""
                }`}
            >
              {value ?? "N/A"}
            </div>
          );
        }

        return columnProps;
      })
      : [];


  const newColumn = {
    Header: "Chart",
    accessor: "newColumn",
    Cell: ({ row }) => {

      return <div style={{
        background: 'var(--Gradient-1, radial-gradient(453.04% 131.96% at 1.22% 92.31%, #0d56eb 0%, #0640b9 100%))', borderRadius: '5px', padding: '4px 5px', cursor: 'pointer'
      }} onClick={() => {
        setCandleStickModal(true);
        setCandleStickSymbol(row.original.symbol);
        setSelectedTradeDate(row.original.date);
        setCandleStickTime(row.original.date);
        handleRowClick(row)
      }}>Open Chart</div>
    },
  };

  // columnss.splice(1, 0, newColumn);


  return (
    <>
      <div className="newTradeHistoryContainer">
        <div className="headerSection">
          <h3>Trading Activity</h3>

          <div className="filter_container">
            {add && (
              <button
                className="addButton"
                ref={tradeButtonRef}
                onClick={() => setCreateTradeVisibility((prev) => !prev)}
              >
                <AddIcon />
                Add Trade
              </button>
            )}
            <button
              ref={buttonRef}
              onClick={() => setFilterVisibility((prev) => !prev)}
            >
              Filters
            </button>

            <div
              ref={filterRef}
              className={`filterWrapper ${filterVisibility ? "filterVisible" : "filterHidden"
                }`}
            >
              {TradingHistory && TradingHistory.length > 0 ? (
                filters?.map((filter) => (
                  <div
                    className={`filterItems ${selectedFilters[filter] ? "checked" : ""
                      }`}
                    key={filter}
                    onClick={() => handleFilterToggle(filter)}
                    style={{ cursor: "pointer" }}
                  >
                    {selectedFilters[filter] ? (
                      <CheckedCheckbox />
                    ) : (
                      <UncheckedCheckbox />
                    )}
                    <span style={{ color: "#fff" }}>{filter}</span>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: "center", color: "#fff" }}>
                  No Data to filter
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="newTradeHistoryWrapper">
          <ReactTable
            columns={columnss || []}
            data={(filteredData || []).reverse()}
          />
          {/* <TradingViewChart
            priceData={priceData}
            tradeMarkers={tradeMarkers}
            chartOptions={chartOptions}
          /> */}
        </div>
      </div>
      <div
        className={`createTradeJournalContainer ${createTradeVisibility ? "traderVisible" : "traderHidden"
          }`}
      >
        <div className="createJournalWrapper" ref={traderRef}>
          <CreateTrader
            handleCross={handleCross}
            handleFormSubmit={handleFormSubmit}
          />
        </div>
        <CombinedPopup
          type={PopUpType}
          trigger={SPopup}
          setTrigger={setSPopup}
          head={CombinedPUHead}
          subhead={CombinedPUBody}
          setShow={setShow}
        />
      </div>
      {candleStickModal &&
        <>
          {/* <div className="chart-overlay" onClick={() => setCandleStickModal(false)} /> */}
          <div className="candleChart">
            <div className="candleChartHeader">
              <div className="candle-chart-filter" ref={containerRef}>

                {/* {dateRanges?.map((range, index) => (
                  <button
                    key={index}
                    className={`range-button ${active === range.value ? 'active' : ''}`}
                    onClick={() => handleClick(range.value)}
                  >
                    {range.label}
                  </button>
                ))} */}
              </div>
              {/* <div className="time-frame-filters">
                {timeFrames?.[active]?.map((timeFrame, index) => {
                  return (
                    <div key={index} className={`${activeTimeFrame === timeFrame ? 'active-time-frame' : ''}`} onClick={() => setActiveTimeFrame(timeFrame)}>{timeFrame}</div>
                  )
                })}
              </div> */}

              <button className="close-button" onClick={() => {
                setCandleStickModal(false);
                setCandleStickTime(null);
                setCandleStickSymbol(null);
                setActive('1d')
              }}>
                ×
              </button>
            </div>
            {/* <CandleStickChart  period={period} selectedDate={selectedTradeDate} symbol={candleStickSymbol} candleStickTime={candleStickTime} positions={positions} setPositionInfo={setPositionInfo} />
            <TradeDetailsCard trade={positionInfo?.first ? positionInfo?.info?.[0] : positionInfo?.info?.[1]} /> */}
          </div>
        </>
      }
    </>
  );
};

export default NewTradingHistory;
